
    <div class="container-fluid container-md">
        <div class="row ">
            <!-- LEFT SIDE BAR -->
            <div class="col-sm-2 col-md-3 d-flex flex-column text-sm-end text-md-start align-items-lg-start left_sidebar border-end">
                <app-left-sidebar [Username]="Username"></app-left-sidebar>
            </div>

            <!-- MAIN SECTION -->
            <div class="col-12 col-sm-10 col-md-9 col-lg-6  main_bar ">
                <div class="row d-flex justify-content-between align-items-center ps-1">
                    <div class="col-1 pt-2">
                        <div><span class="fs-4 fw-bold">Post</span></div>
                    </div>
                    <div class="col-1 me-3">
                        <div><span class="fs-4"><i class="fa fa-star"></i> </span></div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col pt-2 ">
                        <div class="row  d-flex  justify-content-between align-items-center post-container">
                            <!-- POST 1 -->
                            <ng-container *ngIf="UserPostData">
                                <app-post-detail (postEditedOrDeleted)="getUserPostsDataNew(true)"
                                                 (reactionsUpdated)="onReactionsUpdated($event.postId, $event.reactions)"
                                                 [Username]="Username"
                                                 [UserID]="UserID"
                                                 [postData]="UserPostData"
                                                 [pageType]="'post'">
                                </app-post-detail>
                            </ng-container>
                            <div *ngIf="isLoading">
                                Loading more posts...
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <!-- This is where the Replies are listed -->
                    <div class="col pt-2 ">
                        <div class="row  d-flex  justify-content-between align-items-center ">
                            <ng-container *ngFor="let postData of UserReplyPostsData; let i = index">
                                <div [id]="'post' + ((currentPage - 1) * pageSize + i)" >

                                    <!-- Main Post Reply -->
                                    <div class="reply-thread">
                                        <!--<div class="reply-line"></div>--> <!-- Vertical line -->
                                        <div class="reply-content post-container" (click)="navigateToPost(postData.UserName, postData.TSID)">
                                            <!--<img class="profile-image" [src]="'./img_profile/' + postData.UserID + '/' + postData.UserImg" alt="User Profile">-->
                                            <app-post-detail (postEditedOrDeleted)="getUserReplyPostsData(true)"
                                                             (reactionsUpdated)="onReactionsUpdated($event.postId, $event.reactions)"
                                                             [Username]="Username"
                                                             [UserID]="UserID"
                                                             [postData]="postData"
                                                             [pageType]="'postReply'">
                                            </app-post-detail>
                                        </div>
                                    </div>

                                    <!-- First-Level Replies -->
                                    <div *ngIf="postData.replies?.length > 0" class="nested-replies">
                                        <ng-container *ngFor="let nestedReply of postData.replies">
                                            <div class="nested-reply-container ">
                                                <div class="reply-thread">
                                                    <div class="reply-line"></div> <!-- Vertical line -->
                                                    <div class="reply-content post-container" (click)="navigateToPost(nestedReply.UserName, nestedReply.TSID)">
                                                        <app-post-detail (reactionsUpdated)="onReactionsUpdated($event.postId, $event.reactions)"
                                                                         [Username]="Username"
                                                                         [UserID]="UserID"
                                                                         [postData]="nestedReply"
                                                                         [pageType]="'postNestedReply'">

                                                        </app-post-detail>
                                                    </div>
                                                </div>

                                                <!-- Recursive Replies -->
                                                <div *ngIf="nestedReply.replies?.length > 0" class="nested-replies">
                                                    <ng-container *ngFor="let subReply of nestedReply.replies">
                                                        <div class="nested-reply-container ">
                                                            <div class="reply-thread">
                                                                <div class="reply-line"></div> <!-- Vertical line -->
                                                                <div class="reply-content post-container" (click)="navigateToPost(subReply.UserName, subReply.TSID)">
                                                                    <app-post-detail (reactionsUpdated)="onReactionsUpdated($event.postId, $event.reactions)"
                                                                                     [Username]="Username"
                                                                                     [UserID]="UserID"
                                                                                     [postData]="subReply"
                                                                                     [pageType]="'postNestedSubReply'">

                                                                    </app-post-detail>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </div>

                                                <!-- Show More Replies -->
                                                <div *ngIf="nestedReply.showMore" class="show-more">
                                                    <button (click)="loadMoreReplies(nestedReply.TSID)">Show More Replies</button>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>

                                    <!-- Show More Replies for First-Level Replies -->
                                    <div *ngIf="postData.showMore">
                                        <button (click)="loadMoreReplies(postData.TSID)">Show More Replies</button>
                                    </div>
                                </div>
                                <div *ngIf="isLoading">
                                    Loading more posts...
                                </div>
                            </ng-container>

                        </div>
                    </div>
                </div>

            </div>
            <!-- RIGHT SIDE BAR -->
            <div class="col-lg-3 d-none d-lg-block  w-25 h-25 right_side_bar">
                <div class="">
                    <app-search-bar></app-search-bar>
                    <!--                    <div class="bg-opacity-10 bg-black rounded-pill">
                            <div class="row d-flex align-items-center ">
                                <div class="col-2 text-end fs-6">
                                    <span><i class="fa fa-magnifying-glass ps-4"></i></span>
                                </div>
                                <div class="col-10"><input type="text"
                                        class="form-control-lg border-0 me-1 w-75 bg-transparent"
                                        placeholder="Search Truth Shorts"></div>
                            </div>
                        </div>-->
                    <div class="row bg-opacity-10 bg-black mx-1 my-2 pb-3 rounded-3">
                        <div class="col">
                            <div class="trending">
                                <p class="fs-6 fw-bold py-2">Trends for you</p>
                                <div class="row">
                                    <div class="col-9">
                                        <p class="m-0">Trending in USA</p>
                                    </div>
                                    <div class="col-3 text-end">
                                        <span><i class="fa fa-ellipsis pe-2"></i></span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <p class="fs-6 fw-bold mb-0">Donald Trump</p>
                                        <p class="">12.7k Posts</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-9">
                                        <p class="m-0">Technology . Trending</p>
                                    </div>
                                    <div class="col-3 text-end">
                                        <span><i class="fa fa-ellipsis pe-2"></i></span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <p class="fs-6 fw-bold mb-0">CrowdStrike</p>
                                        <p class="">101k Posts</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-9">
                                        <p class="m-0">Trending in Politics</p>
                                    </div>
                                    <div class="col-3 text-end">
                                        <span><i class="fa fa-ellipsis pe-2"></i></span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <p class="fs-6 fw-bold mb-0">Joe Biden</p>
                                        <p class="">132k Posts</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-9">
                                        <p class="m-0">Trending in USA</p>
                                    </div>
                                    <div class="col-3 text-end">
                                        <span><i class="fa fa-ellipsis pe-2"></i></span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <p class="fs-6 fw-bold mb-0">Sky News</p>
                                        <p class="">8,104 Posts</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-9">
                                        <p class="m-0">Trending in USA</p>
                                    </div>
                                    <div class="col-3 text-end">
                                        <span><i class="fa fa-ellipsis pe-2"></i></span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <p class="fs-6 fw-bold mb-0">Azure</p>
                                        <p class="">141k Posts</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-9">
                                        <p class="m-0">Trending in USA</p>
                                    </div>
                                    <div class="col-3 text-end">
                                        <span><i class="fa fa-ellipsis pe-2"></i></span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <p class="fs-6 fw-bold mb-0">The IT</p>
                                        <p class="">2,449 Posts</p>
                                    </div>
                                </div>

                                <span class="text-info">Show more</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
 